import { lazy } from 'react';
import { Settings20Regular } from '@fluentui/react-icons';
import { FeatureDefinition } from '../../types/feature.types';

export const settingsDefinition: FeatureDefinition = {
  id: 'settings',
  name: 'Config',
  icon: Settings20Regular,
  component: lazy(() => import('./Settings')),
  order: 100,
  enabled: true,
};
